import {useState, useEffect, useRef}        from "react";
import {useLoader}                          from "components/Covers/loadingCover";
import {useActionModal}                     from "components/Covers/confirmAction";
import {useInfoMsgModal}                    from "components/Covers/infoMessageModal";
import {useToastMessage}                    from "components/Covers/toastMessage";
import {InputGeneral}                       from "components/Field/field";
import {BtnCloseAction}                     from "components/Buttons/Close/BtnClose";
import MainStyle                            from "components/UI/main.module.scss";
import {getSectorList,getSectorByID,getPermissionList,updateSector,deleteSector}  from "./sectorService";
// BEGIN AG AGRID
import {AgGridReact}                        from "ag-grid-react";
import {AllCommunityModule,ModuleRegistry}  from 'ag-grid-community';
import {AG_GRID_LOCALE_BR}                  from '@ag-grid-community/locale';
import {q3x_FunData, 
        DefaultLoadingLogo, 
        DavidCopperfield,
        Heimdall,
        GetLabel,
        GetAppLang,
        SetLastFeature}                     from "Utilities/utils";
import {DisplayGridDatetime}                from "components/Date/date";

import { Select }                           from "antd";
import { useNavigate }                      from "react-router-dom";

let blank_sector_obj = {
    'SECTOR_ID': 0,
    'SECTOR_DESC': "",
    'PERMISSIONS': []
};
let blank_permission_template = {
    'PERMISSION_ID': 0, 
    'PERMISSION_DESC': "", 
    'CAPABILITIES_C': "N", 
    'CAPABILITIES_R': "N", 
    'CAPABILITIES_U': "N",  
    'CAPABILITIES_D': "N"
};
let appLang = null;
/*
const SearchableDropdownList = ({
    className,
    style,
    onChange,
    listOfItems,
    placeholder,
    id,
    name,
    defaultValue,
    title,
    popupClassName}) => {
  return (
    <Select
      name={name}
      id={id}
      placeholder={placeholder}
      optionFilterProp="children"
      filterOption={(input, option) =>
        (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
      }
      options={listOfItems}
      className={className}
      style={style}
      onChange={onChange}
      defaultValue={defaultValue}
      title={title}
      popupClassName={popupClassName}
    />
  );
};
*/

const SearchableDropdownList = ({
    className,
    style,
    onChange,
    onSearch,
    listOfItems,
    placeholder,
    id,
    name,
    defaultValue,
    title,
    popupClassName,
    value,
  }) => {
    return (
      <Select
        showSearch
        allowClear
        id={id}
        name={name}
        value={value} // use directly from props
        placeholder={placeholder}
        className={className}
        style={style}
        title={title}
        popupClassName={popupClassName}
        options={listOfItems}
        optionFilterProp="label"
        filterOption={(input, option) =>
          (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
        }
        onChange={(val, option) => {
          onChange?.(val, option); // lift change to parent
        }}
        onSearch={(val) => {
          onSearch?.(val);
        }}
        notFoundContent={null}
      />
    );
};

const SectorEditPanel = ({setProps, data}) => {
    const { showLoader, hideLoader }                            = useLoader();                  // Control over the loader
    const { showInfoMessage }                                   = useInfoMsgModal();            // Modal message control 
    const { showActionMessage }                                 = useActionModal();             // Modal message + action control     
    const { showToastMessage            }                       = useToastMessage();            // Toast message display
    const [sysPermission,   setSysPermission]                   = useState([]);                 // Default permission syslist
    const [dropdownList,    setDropdownList]                    = useState([]);                 // Used in the format of antd
    const [sectorObj,       setSectorObj]                       = useState(blank_sector_obj);   // Sector Object
    
    const handleExit = () => {
        setProps({ setScreen: 1, data: blank_sector_obj });
    };

    const BtnExit = () => {
        showActionMessage(
          { header: GetLabel(appLang, 54), message: <>{GetLabel(appLang, 102)}<br/>{GetLabel(appLang, 103)}</> },
          { confirm_action: () => handleExit()}
        );
    };       

    const handleSave = async () => {
        if (sectorObj.SECTOR_DESC == "") {
            showInfoMessage({'header': "Atenção", 'message': GetLabel(appLang, 256)});
            return;            
        }
        if (sectorObj.PERMISSIONS.length <= 0) {
            showInfoMessage({'header': "Atenção", 'message': GetLabel(appLang, 257)});
            return;
        }
        showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
        let fetchedData    = await updateSector(sectorObj);
        if (fetchedData) {
            if (fetchedData?.status?.statusCode == 0) {
                hideLoader();
                showToastMessage({'header': GetLabel(appLang, 14), 'message': GetLabel(appLang, 106)});
                if (sectorObj.SECTOR_ID === 0) {
                    setProps({ setScreen: 1, data: blank_sector_obj });
                }                
            }
            else {
                hideLoader();
                showInfoMessage({'header': GetLabel(appLang, 107), 'message': fetchedData.status.message});
            }
        }
    };

    const handleDelete = async () => {
        showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
        let fetchedData = await deleteSector(sectorObj.SECTOR_ID);
        if (fetchedData) {
            if (fetchedData?.status?.statusCode == 0) {
                hideLoader();
                setProps({ setScreen: 1, data: blank_sector_obj });   
            }
            else {
                hideLoader();
                showInfoMessage({'header': GetLabel(appLang, 107), 'message': fetchedData.status.message});
            }
        }
    };

    const handleChange = (updatedValues) => {        
        setSectorObj(prevState => ({
            ...prevState,
            ...updatedValues
        }));
    };

    const handlePermissionList = (per_id) => {
        if (sectorObj.PERMISSIONS.some((perm) => perm.PERMISSION_ID === per_id)) {
            return;
        }
    
        // Find permission in the system list
        const foundSysPerm = sysPermission.find((perm) => perm.PERMISSION_ID === per_id);
        if (!foundSysPerm) return; // Safety check in case the permission isn't found
    
        // Create a new permission object
        const newPermission = {
            ...blank_permission_template, // Copy the template
            PERMISSION_ID: foundSysPerm.PERMISSION_ID,
            PERMISSION_DESC: foundSysPerm.PERMISSION_DESC,
            CAPABILITIES_C: "N",
            CAPABILITIES_R: "Y",
            CAPABILITIES_U: "N",
            CAPABILITIES_D: "N",
        };
    
        // Update state correctly by creating a new array
        setSectorObj(prevState => ({
            ...prevState,
            PERMISSIONS: [...prevState.PERMISSIONS, newPermission]
        }));

    };
    
    const RowPermission = ({ prop }) => {
        const [perm_read, setRead]      = useState(prop.CAPABILITIES_R);
        const [perm_create, setCreate]  = useState(prop.CAPABILITIES_C);
        const [perm_edit, setEdit]      = useState(prop.CAPABILITIES_U);
        const [perm_delete, setDelete]  = useState(prop.CAPABILITIES_D);
    
        const handleCheckboxChange = (e) => {
            let newRead     = perm_read;
            let newCreate   = perm_create;
            let newEdit     = perm_edit;
            let newDelete   = perm_delete;
    
            switch (e.target.name) {
                case "read":  
                    newRead = perm_create === "Y" ? "N" : "Y"; 
                    setRead(newRead);
                    break;
                case "create":  
                    newCreate = perm_create === "Y" ? "N" : "Y"; 
                    setCreate(newCreate);
                    break;
                case "edit":    
                    newEdit = perm_edit === "Y" ? "N" : "Y"; 
                    setEdit(newEdit);
                    break;
                case "delete":  
                    newDelete = perm_delete === "Y" ? "N" : "Y"; 
                    setDelete(newDelete);
                    break;
                default: break;
            }
    
            // Update sectorObj directly within this function
            setSectorObj(prevState => ({
                ...prevState,
                PERMISSIONS: prevState.PERMISSIONS.map((perm) => 
                    perm.PERMISSION_ID === prop.PERMISSION_ID
                        ? {
                            ...perm,
                            CAPABILITIES_C: newCreate,
                            CAPABILITIES_R: newRead,
                            CAPABILITIES_U: newEdit,
                            CAPABILITIES_D: newDelete,
                        }
                        : perm
                ),
            }));
        };
        return (
            <>
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_lg_3}>
                        <div className={MainStyle.text_center}>
                            <p className={[MainStyle.text_body, MainStyle.fs_6, MainStyle.fw_semibold].join(" ")}>
                                {GetLabel(appLang, 258)}
                            </p>
                            <input
                                id={`${prop.PERMISSION_ID}`}
                                type="checkbox"
                                name={"read"}
                                checked={perm_read === "Y" ? true : false}
                                onChange={handleCheckboxChange}
                                style={{ transform: "scale(1.5)" }}
                                disabled={true}
                            />
                        </div>
                    </div>
                    <div className={MainStyle.col_lg_3}>
                        <div className={MainStyle.text_center}>
                            <p className={[MainStyle.text_body, MainStyle.fs_6, MainStyle.fw_semibold].join(" ")}>
                                {GetLabel(appLang, 259)}
                            </p>
                            <input
                                id={`${prop.PERMISSION_ID}`}
                                type="checkbox"
                                name={"create"}
                                checked={perm_create === "Y"? true : false}
                                onChange={handleCheckboxChange}
                                style={{ transform: "scale(1.5)" }}
                            />
                        </div>
                    </div>
                    <div className={MainStyle.col_lg_3}>
                        <div className={MainStyle.text_center}>
                            <p className={[MainStyle.text_body, MainStyle.fs_6, MainStyle.fw_semibold].join(" ")}>
                                {GetLabel(appLang, 115)}
                            </p>
                            <input
                                id={`${prop.PERMISSION_ID}`}
                                type="checkbox"
                                name={"edit"}
                                checked={perm_edit === "Y"? true : false}
                                onChange={handleCheckboxChange}
                                style={{ transform: "scale(1.5)" }}
                            />
                        </div>
                    </div>
                    <div className={MainStyle.col_lg_3}>
                        <div className={MainStyle.text_center}>
                            <p className={[MainStyle.text_body, MainStyle.fs_6, MainStyle.fw_semibold].join(" ")}>
                                {GetLabel(appLang, 260)}
                            </p>
                            <input
                                id={`${prop.PERMISSION_ID}`}
                                type="checkbox"
                                name={"delete"}
                                checked={perm_delete === "Y"? true : false}
                                onChange={handleCheckboxChange}
                                style={{ transform: "scale(1.5)" }}                          
                            />
                        </div>
                    </div>
                </div>
            </>
        );
    };

    const SectorPermissionList = ({list}) => {
        //const [listState, setListState] = useState([]);

        const handleDelete = (item_id) => {
            setSectorObj(prevState => ({
                ...prevState,
                PERMISSIONS: prevState.PERMISSIONS.filter(perm => perm.PERMISSION_ID !== item_id)
            }));
        };

    
        useEffect(() => {
            //setListState(list);
        }, [list]);
    
    
        return (
            <>
                <div className={MainStyle.mt_5}/>
                <div className={[MainStyle.border_bottom, MainStyle.my_3, MainStyle.mx_3].join(" ")}>
                    <span className={[MainStyle.fs_6,
                                      MainStyle.text_body,
                                      MainStyle.fw_semibold].join(" ")}>{GetLabel(appLang, 261)}:</span>
                </div>
                <div className={MainStyle.mt_5}/>
                {list.map((item, index) => (
                    <div className={MainStyle.my_3}>
                        <div 
                            key={`perm-row-${index}-id-${item.PERMISSION_ID}`} 
                            className={MainStyle.row}
                        >
                            <div className={MainStyle.col_lg_12}>
                                <div className={[MainStyle.bg_card,
                                                 MainStyle.border,
                                                 MainStyle.rounded,
                                                 MainStyle.shadow_sm,
                                                 MainStyle.mx_3
                                ].join(" ")}>
                                    <div className={MainStyle.row}>
                                        <div className={MainStyle.col_11}>
                                            <div className={[MainStyle.text_center, MainStyle.mt_1].join(" ")}>
                                                <span className={[MainStyle.fs_6,
                                                                  MainStyle.text_body,
                                                                  MainStyle.fw_semibold].join(" ")}>
                                                    {item.PERMISSION_DESC}
                                                </span> 
                                            </div>
                                        </div>
                                        <div className={MainStyle.col_1}>
                                            <div className={MainStyle.me_3}>
                                                <div className={MainStyle.align_ico_end}>
                                                    <div 
                                                        className={[MainStyle.table_btn_icon, MainStyle.shadow_sm, MainStyle.p_1].join(" ")}
                                                        onClick={() => {handleDelete(item.PERMISSION_ID)}}                                                 
                                                    >
                                                        <svg 
                                                            xmlns="http://www.w3.org/2000/svg" 
                                                            viewBox="0 0 448 512"
                                                            className={[MainStyle.small_ico_generic].join(" ")}
                                                        >
                                                            <path d="M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128z"/>
                                                        </svg>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <RowPermission key={`perm-row-${index}-id-${item.PERMISSION_ID}`}  prop={item} />
                            </div>
                        </div>
                    </div>
                ))}
            </>
        );
    };

    const BtnSave = () => {
        showActionMessage(
          { header: GetLabel(appLang, 54), message: GetLabel(appLang, 262) },
          { confirm_action: () => handleSave()}
        );
    };

    const BtnDelete = () => {
        showActionMessage(
          { header: GetLabel(appLang, 54), message:  GetLabel(appLang, 263)},
          { confirm_action: () => handleDelete()}
        );
    };

    useEffect(() => {
        const fetchSysData = async () => {
            let fetchedData = await getPermissionList();
            if (fetchedData) {
                if (fetchedData?.status?.statusCode == 0) {
                    fetchedData = fetchedData.response.content;
                    if (Array.isArray(fetchedData) && fetchedData.length > 0) {

                        //  Keep the orginal format data
                        setSysPermission(fetchedData);
                        
                        let tmp = [];
                        for (var i = 0; i < fetchedData.length; i++) {
                            tmp.push(
                                {
                                    value : fetchedData[i].PERMISSION_ID, 
                                    label: fetchedData[i].PERMISSION_DESC
                                });
                        }                
                        setDropdownList(tmp);
                    }
                }
                else {
                    showInfoMessage({'header': GetLabel(appLang, 107), 'message': fetchedData.status.message});
                }
            
            }
        };
        const fetchData = async (sector_id) => {
            try {
                showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
                let fetchedData = await getSectorByID(sector_id);
                if (fetchedData) {
                    if (fetchedData?.status?.statusCode == 0) {
                        if (fetchedData?.response?.content) {
                            fetchedData = fetchedData.response.content;
                            setSectorObj(fetchedData || blank_sector_obj);
                            hideLoader();
                        }
                    }
                    else {
                        hideLoader();
                        showInfoMessage({'header': GetLabel(appLang, 107), 'message': fetchedData.status.message});
                    }
                }                        
            } 
            catch (error) {
                setSectorObj(blank_sector_obj);
            }
        };
        if (data?.SECTOR_ID && data.SECTOR_ID !== 0) {
            fetchData(data.SECTOR_ID);
        } 
        else {
            setSectorObj(blank_sector_obj);
        }
        fetchSysData();
    }, [data]);

    return(
        <>
            <div className={[MainStyle.bg_card, MainStyle.shadow, MainStyle.border, MainStyle.rounded].join(" ")}>
                <div className={MainStyle.mt_3}/>
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_1}>                            
                    </div>
                    <div className={MainStyle.col_11}>
                        <div className={[MainStyle.text_end, MainStyle.mx_3].join(" ")}>
                            {<BtnCloseAction click_action={BtnExit}/>}
                        </div>
                    </div>
                </div>
                <div className={MainStyle.mt_3}/>


                <div className={[MainStyle.bg_card_inner,
                                 MainStyle.border_top,
                                 MainStyle.border_bottom,
                                 MainStyle.border_end].join(" ")}>

                    <div className={MainStyle.mt_5}/>
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg_1}/>
                        <div className={MainStyle.col_lg_5}>
                            <div className={[MainStyle.text_start, MainStyle.ms_3].join(" ")}>
                                <span className={[MainStyle.fs_6,
                                                  MainStyle.text_body,
                                                  MainStyle.fw_semibold
                                                ].join(" ")}
                                >
                                    {GetLabel(appLang, 264)}*:
                                </span>
                            </div>
                        </div>
                        <div className={MainStyle.col_lg_5}>
                            <div className={MainStyle.mx_3}>
                                <InputGeneral 
                                                value={sectorObj.SECTOR_DESC}
                                                className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1].join(" ")} 
                                                onChange={(event) => handleChange({ SECTOR_DESC: q3x_FunData(event.target.value) })}
                                                placeholder={GetLabel(appLang, 265)}
                                                maxLength={150}
                                />
                                <span className={[MainStyle.ms_2, MainStyle.text_body_faded, MainStyle.fs_8].join(" ")}>{sectorObj.SECTOR_DESC.length} {GetLabel(appLang, 44)} 150 {GetLabel(appLang, 45)}.</span>
                            </div>
                        </div>
                        <div className={MainStyle.col_lg_1}/>
                    </div>
                    <div className={[MainStyle.py_3, MainStyle.mx_5].join(" ")}/>
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg_1}/>
                        <div className={MainStyle.col_lg_5}>
                            <div className={[MainStyle.text_start, MainStyle.ms_3].join(" ")}>
                                <span className={[MainStyle.fs_6,
                                                  MainStyle.text_body,
                                                  MainStyle.fw_semibold
                                                ].join(" ")}
                                >
                                    {GetLabel(appLang, 266)}*:
                                </span>
                            </div>
                        </div>
                        <div className={MainStyle.col_lg_5}>
                            <div className={MainStyle.mx_3}>
                                <SearchableDropdownList    
                                    placeholder={GetLabel(appLang, 267)}                                
                                    listOfItems={dropdownList}
                                    style={{ width: "100%" }}  
                                    className={MainStyle.antd_custom_select}                               
                                    popupClassName={MainStyle.antd_custom_select}                              
                                    onChange={(event) => {                                    
                                        handlePermissionList(event);
                                    }}
                                />
                            </div>
                        </div>
                        <div className={MainStyle.col_lg_1}/>
                    </div>
                    {<SectorPermissionList list={sectorObj.PERMISSIONS}/>}
                </div>
                
                <div className={MainStyle.my_5}/>

            </div>
            {/*--------------------------------------------------------------------------*/}            
            <div className={MainStyle.row}>
                <div className={MainStyle.col_lg_7}></div>
                <div className={MainStyle.col_lg_2}>
                    {DavidCopperfield(2,89,6) && (
                        sectorObj.SECTOR_ID != 0 ? 
                            <div className={[MainStyle.mt_3].join(" ")}>
                                <button
                                    style={{width: '100%'}}
                                    className={[MainStyle.btn_delete, 
                                                MainStyle.rounded_3, 
                                                MainStyle.border, 
                                                MainStyle.shadow_sm, 
                                                MainStyle.fs_6,
                                                MainStyle.py_3,
                                                MainStyle.px_3].join(" ")}
                                    onClick={BtnDelete}
                                >
                                    {GetLabel(appLang, 114)}
                                </button>
                            </div>
                    : 
                        null
                    )}
                </div>
                <div className={MainStyle.col_lg_1}></div>
                <div className={MainStyle.col_lg_2}>
                    <div className={[MainStyle.mt_3].join(" ")}>
                        <button
                            style={{width: '100%'}}
                            className={[MainStyle.btn_green, 
                                        MainStyle.rounded_3, 
                                        MainStyle.border, 
                                        MainStyle.shadow_sm, 
                                        MainStyle.fs_6,
                                        MainStyle.text_white,
                                        MainStyle.py_3,
                                        MainStyle.px_3].join(" ")}
                            onClick={BtnSave}
                        >
                            {GetLabel(appLang, 49)}
                        </button>
                    </div>
                </div>
            </div>
            {/*--------------------------------------------------------------------------*/}                                    
        </>
    );

};

const SectorTableGrid = ({setProps}) => {
    const [ isLoading,  setIsLoading]            = useState(false);   // Loading fetch control
    const { showLoader, hideLoader }             = useLoader();       // Control over the  
    const [searchText,  setSearchText]           = useState('');      // Searched text state
    const [rowData,     setRowData]              = useState([]);      // State of rows def 
    const [columnDefs,  setcolumnDefs]           = useState([]);      // State of columns def
    const gridRef                                = useRef();
    const { showInfoMessage }                    = useInfoMsgModal(); // Modal message control 

    ModuleRegistry.registerModules([AllCommunityModule]);

    const gridOptions = {
        pagination: true, // Enable pagination
        paginationPageSize: 20, // Number of rows per page
        localeText: GetAppLang() === "PT" ? AG_GRID_LOCALE_BR : null,
        suppressHorizontalScroll: false,
        embedFullWidthRows: true,
        groupSuppressBlankHeader: false,
        enableCellTextSelection: true
    };

    const EditItem = (props) => {
        const handleData = () => {
            let obj_copy = JSON.parse(JSON.stringify(blank_sector_obj));
            obj_copy.SECTOR_ID = props.data.SECTOR_ID;
            setProps({ setScreen: 2, data: obj_copy });
        };
        return(
            <>
                <div 
                    onClick={() => {handleData()}} 
                    className={[MainStyle.table_btn_icon, MainStyle.shadow_sm, MainStyle.p_1, MainStyle.text_center].join(" ")}>
                    <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        viewBox="0 0 512 512"
                        className={[MainStyle.small_ico_generic].join(" ")}
                    >
                        <path d="M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160L0 416c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7-14.3 32-32 32L96 448c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 64z"/>
                    </svg>
                </div>
            </>
        );
    };

    const defaultCol = [
        DavidCopperfield(2,89,4) && {
          headerName: GetLabel(appLang, 115),
          field: 'editar',
          cellRenderer: EditItem,
          cellClass: [MainStyle.table_text_center].join(" "), 
          headerClass: MainStyle.table_header_center,
          flex: 0,
        },
        { headerName: GetLabel(appLang, 34),  field: "SECTOR_ID"      ,filter: true , flex: 0, headerClass: MainStyle.table_header_center, cellClass: [MainStyle.table_text_center].join(" "),}    ,    
        { headerName: GetLabel(appLang, 268), field: "SECTOR_DESC"    ,filter: true , flex: 1,}    ,
        { headerName: GetLabel(appLang, 118), field: "UPDATED"        ,filter: true , flex: 0, cellRenderer: DisplayGridDatetime, }    ,
    ].filter(Boolean);

    const onQuickFilterChanged = (e) => {
        setSearchText(e.target.value);
    };

    useEffect(() => {
        const fetchData = async () => {
            if (!isLoading) {
                setIsLoading(true);
                showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
                let data = await getSectorList();
                if (data) {
                    if (data?.status?.statusCode == 0) {
                        data = data.response.content;
                        setcolumnDefs(defaultCol);
                        let arr = [];
                        for(var j = 0; j < data.length; j++) {
                            arr.push(data[j]);
                        }
                        setRowData(arr);
                        hideLoader();
                        setIsLoading(false);
                    }
                    else {
                        hideLoader();
                        showInfoMessage({'header': GetLabel(appLang, 107), 'message': data.status.message});
                    }
                }
            }
        };
        fetchData();
    },[]);

    return (
        <>
        <div className={[MainStyle.bg_card, MainStyle.shadow, MainStyle.border, MainStyle.rounded].join(" ")}>
            <div className={[MainStyle.px_2, MainStyle.mt_3].join(" ")}>
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_lg_9}></div>
                    <div className={MainStyle.col_lg_3}>
                        <div className={[MainStyle.d_flex].join(" ")}>
                            <div className={[MainStyle.mt_2, MainStyle.me_2].join(" ")}>
                                <svg 
                                    xmlns="http://www.w3.org/2000/svg" 
                                    viewBox="0 0 512 512"
                                    className={MainStyle.small_ico_search_bar}
                                >
                                    <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/>
                                </svg>
                            </div>
                            <InputGeneral 
                                value={searchText}
                                className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1, MainStyle.mb_3].join(" ")} 
                                onChange={onQuickFilterChanged}
                                placeholder={GetLabel(appLang, 33)}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div style={{ height: '40rem'}}>
                <AgGridReact 
                    ref={gridRef}
                    rowData={rowData}
                    columnDefs={columnDefs}
                    gridOptions={gridOptions}
                    quickFilterText={searchText}
                />
            </div>
        </div>
    </>);
};

export const SectorPage = () => {
    const [ screenType, setScreenType ]       = useState(1);
    const [ defaultData, setDefaultData]      = useState({});
    const { showActionMessage }               = useActionModal();
    const navigate                            = useNavigate();    

    const BtnNew = () => {
        handleChange({ setScreen: 2,data: blank_sector_obj });
    };

    const handleChange = ({ setScreen, data }) => {
        setDefaultData({ ...data });
        setScreenType(setScreen);
    };

    useEffect(() => {
        if (!Heimdall([2])) {
            navigate('/home');
        }
        else {
            SetLastFeature(2);
        }        
    }, [screenType, defaultData]);

    return (
        <>
        {
        screenType == 1? 
        <>
            <div>
                <p className={[MainStyle.fs_4, MainStyle.mx_3, MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>
                    {GetLabel(appLang, 269)}
                </p>
            </div>
            {DavidCopperfield(2,89,0)  && (
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_lg_10}></div>
                    <div className={MainStyle.col_lg_2}>
                        <div className={[MainStyle.mx_3].join(" ")}>
                            <button
                                style={{width: '100%'}}
                                className={[MainStyle.btn_blue, 
                                            MainStyle.rounded_3, 
                                            MainStyle.border, 
                                            MainStyle.shadow_sm, 
                                            MainStyle.fs_6,
                                            MainStyle.text_white,
                                            MainStyle.py_3,
                                            MainStyle.px_5].join(" ")}
                                onClick={BtnNew}
                            >
                                {GetLabel(appLang, 120)}
                            </button>
                        </div>
                    </div>
                </div>
            )}            
            <div className={MainStyle.row}>
                <div className={MainStyle.col_12}>
                    <div className={[MainStyle.mx_3, MainStyle.my_3].join(" ")}>
                        <SectorTableGrid setProps={handleChange}/>
                    </div>
                </div>
            </div>
            <div className={MainStyle.pb_3}></div>
        </>
        : 
        <>
            <div>
                <p className={[MainStyle.fs_4, MainStyle.mx_3, MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>
                    {GetLabel(appLang, 269)}
                </p>
            </div>
            <div className={[MainStyle.mx_3, MainStyle.my_3].join(" ")}>
                <SectorEditPanel setProps={handleChange} data={defaultData} />
            </div>
        </>
        }
        </>
    );
};